import { render, staticRenderFns } from "./BaseFileViewer.vue?vue&type=template&id=566cd304&scoped=true&"
import script from "./BaseFileViewer.vue?vue&type=script&lang=js&"
export * from "./BaseFileViewer.vue?vue&type=script&lang=js&"
import style0 from "./BaseFileViewer.vue?vue&type=style&index=0&id=566cd304&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566cd304",
  null
  
)

export default component.exports